module.exports = __webpack_public_path__ + "static/media/logo-tux.edfd5daf.svg";